import React, { Component } from 'react';
import { FORMAT_NUMBER, CURRENCY, SYMBOL } from '../libs/utils/Const';
import $ from 'jquery';
import '../css/ticketDelivery.css'
class TicketDeliveryModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeAction = () => {
        const { CloseBillModal } = this.props;
        $('#ticketModal').on('hidden.bs.modal', function () {
            CloseBillModal(true);
        });
    };

    render() {
        const { newOrderModel, _user } = this.props;
        return (
            <div className="modal fade" id="ticketDeliveryModal" role="dialog" tabIndex="-1" aria-labelledby="ticketModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content" style={{ backgroundColor: "#fff0", border: "none" }}>
                        <div className="modal-body">
                            <div className="ticketDelivery" style={{ fontSize: 12 }}>
                                <div className="m-3">
                                    <div className="" >
                                        <div className="text-center" >
                                            <img className="img-fluid d-block mx-auto" src={require('../images/logoTicket.png')} style={{ maxWidth: "200px" }} alt="COUNTER ONE"></img>
                                            <p>{`SUCURSAL: ${_user?.Sucursal.toUpperCase()} `}</p>
                                            <p>{_user?.Branch.Address.toUpperCase()}</p>
                                            <span><strong>COMPROBANTE DE PAGO</strong></span>
                                        </div>
                                        <br />
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td align="left">{newOrderModel.DocDate}</td>
                                                    <td align="right">{newOrderModel.DocTime}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <br />
                                    <div className="text-center mt-3 mb-3">
                                        <h4>{"SUC"+newOrderModel.DocType+newOrderModel.DocEntry}</h4>
                                        <img src={require('../images/sello.png')} alt="Sello" style={{width:"-webkit-fill-available"}}/>
                                    </div>

                                    <br></br>
                                    <table className='mb-5'>
                                        <tbody>
                                            <tr>
                                                <td>Subtotal</td>
                                                <td align="right">{CURRENCY + ' ' + FORMAT_NUMBER.new(newOrderModel.Subtotal)}</td>
                                            </tr>
                                            <tr>
                                                <td>I.V.A.</td>
                                                <td align="right">{CURRENCY + ' ' + FORMAT_NUMBER.new(newOrderModel.Taxes)}</td>
                                            </tr>
                                            <tr>
                                                <td>Descuento 10%</td>
                                                <td align="right">{CURRENCY + ' ' + FORMAT_NUMBER.new(newOrderModel.Discount)}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr style={{ fontSize: 16 }}>
                                                <td>Total</td>
                                                <td align="right">{CURRENCY + ' ' + FORMAT_NUMBER.new(newOrderModel.Total)}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <div className="text-right" style={{marginTop: "10px"}}>
                                    <button className="btn"><i className="fa fa-print" aria-hidden="true" style={{fontSize: "25px", color: "#80808073"}}></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TicketDeliveryModal;